export default __webpack_public_path__ + "static/media/querelle_detail4.549b2ce7.jpg";